import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ContributionDTO} from '../models/ContributionDTO';

@Injectable({
  providedIn: 'root'
})
export class MemberContributionService {
  private url = environment.baseIgnUrl + '/contributions/members/%s';

  constructor(private httpClient: HttpClient) {
  }

  getMemberContribution(optionCode: string, membershipNumber: string, year: string, month: string): Observable<Array<ContributionDTO>> {
    return this.httpClient.get<Array<ContributionDTO>>(this.getUrl(membershipNumber), {params: {year, month, optionCode}});
  }

  getUrl(membershipNumber: string): string {
    return this.url.replace('%s', membershipNumber);
  }
}
